import { DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Batch, BatchRepositoryService, ConfigurationState, eBatchType, FiltersComponent, SelectOption } from 'reg-hub-common';
import { take } from 'rxjs';

@Component({
    selector: 'app-batches-filter',
    templateUrl: './batches-filter.component.html',
    styleUrl: './batches-filter.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BatchesFilterComponent extends FiltersComponent<Batch> implements OnInit {
  protected autoExpand: boolean = false;
  protected bundleID: string = '';

  _batchTypes: SelectOption[] = [
    { label: 'bundles.batchTypes.assetSearch', value: eBatchType.assetSearch },
    { label: 'bundles.batchTypes.debtorSearch', value: eBatchType.debtorSearch },
    { label: 'bundles.batchTypes.regNumberSearch', value: eBatchType.registrationNumberSearch },
    { label: 'bundles.batchTypes.lien', value: eBatchType.lien },
    { label: 'bundles.batchTypes.renewal', value: eBatchType.renewal },
    { label: 'bundles.batchTypes.discharge', value: eBatchType.discharge },
    { label: 'bundles.batchTypes.caBusinessSearch', value: eBatchType.caBusinessSearch },
    { label: 'bundles.batchTypes.caBusinessReport', value: eBatchType.caBusinessReport },
    { label: 'bundles.batchTypes.usBusinessSearch', value: eBatchType.usBusinessSearch },
    { label: 'bundles.batchTypes.usBusinessReport', value: eBatchType.usBusinessReport },
    { label: 'bundles.batchTypes.uboReport', value: eBatchType.ultimateBeneficialOwnershipReport },
    { label: "VINsight", value: eBatchType.vinSight }
    ];

  constructor(
    private activatedRoute: ActivatedRoute,
    batchesRepository: BatchRepositoryService,
    formBuilder: FormBuilder,
    datePipe: DatePipe
  ) {
    super(
      batchesRepository,
      formBuilder,
      datePipe);
  }

  ngOnInit(): void {
    this._filterForm = this.formBuilder.group({
      description: [null],
      batchTypeIDs: [null],
      batchStateIDs: [null],
      isVisible: [true]
    });

    this.activatedRoute.paramMap.subscribe(params => {
      this.bundleID = params.get('bundleID')!;
        this.repo.populateBaseLink([this.bundleID]);
        this.getFirstPage();
    });
  }

  getFirstPage() {
    this._defaultParams = this.buildParamsFromForm(this._filterForm);

    this.activatedRoute.queryParams.pipe(take(1)).subscribe(routeQueryStringParams => {
      const routeQueryStringParamKeys = Object.keys(routeQueryStringParams);

      if (routeQueryStringParamKeys.length > 0) {
        let preFilteredParams = this.buildParamsFromObject(routeQueryStringParams);

        routeQueryStringParamKeys.forEach(key => {
          const control = this._filterForm.get(key);

          if (control) {
            control.setValue(routeQueryStringParams[key]);
            this._filterForm.markAsDirty();
            this.filtered = true;
          }
        })

        this.repo.getFirstPage(preFilteredParams);
      } else {
        this.repo.getFirstPage(this._defaultParams);
      }
    });
  }
}
